define(['santa-components', 'wixappsCore/proxies/mixins/boxProxy'], function (santaComponents, boxProxy) {
    'use strict';

    /**
     * @class proxies.HBox
     * @extends proxies.mixins.boxProxy
     */
    return {
        mixins: [boxProxy],
        getChildrenOrientation() {
            return 'horizontal';
        },

        getReactClass() {
            return santaComponents.utils.createReactElement.bind(null, 'div');
        }
    };
});
